var render, staticRenderFns
import script from "./Parser.vue?vue&type=script&lang=js&"
export * from "./Parser.vue?vue&type=script&lang=js&"
import style0 from "./Parser.vue?vue&type=style&index=0&id=4a7489be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7489be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\CompanyProject\\HF-IM-electron-workbench\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a7489be')) {
      api.createRecord('4a7489be', component.options)
    } else {
      api.reload('4a7489be', component.options)
    }
    
  }
}
component.options.__file = "src/components/DrawerParser/Parser.vue"
export default component.exports